/**
 * useContactCategoryEntryScreen.js
 * --------------------------------
 * Hook for Contact Category create/edit form screen using shared useMasterEntry.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as contactCategoryApi from '../api/contactCategoryApi';

export function useContactCategoryEntryScreen() {
  return useMasterEntry({
    entityName: 'Contact Category',
    apiClient: contactCategoryApi.contactCategoryClient,
    fetchDetail: contactCategoryApi.getContactCategoryDetail,
    createItem: contactCategoryApi.createContactCategory,
    updateItem: contactCategoryApi.updateContactCategory,
    initialForm: {
      name: '',
      description: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Contact Category Name is required.';
      }
      return null;
    },
    listPath: '/masters/contact-category/list',
    transformPayload: (form, operationalStatus) => ({
      name: form.name.trim(),
      description: form.description ? form.description.trim() : null,
      status: operationalStatus === 'active' ? 'Active' : 'Archived',
    }),
    transformDetail: (detail) => ({
      form: {
        name: detail.name || '',
        description: detail.description || '',
      },
      operationalStatus: detail.status === 'Active' ? 'active' : 'inactive',
    }),
  });
}
